import { render, staticRenderFns } from "./AddLotinList.vue?vue&type=template&id=30ff0830&scoped=true"
import script from "./AddLotinList.vue?vue&type=script&lang=js"
export * from "./AddLotinList.vue?vue&type=script&lang=js"
import style0 from "./AddLotinList.vue?vue&type=style&index=0&id=30ff0830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff0830",
  null
  
)

export default component.exports